// extracted by mini-css-extract-plugin
module.exports = {"wrap":"About_wrap_2H9s0"};